import { Component, h } from 'preact';
import linkState from 'linkstate';

import cloneDeep from 'lodash-es/cloneDeep';

import { InquiryDocument } from 'inquiries/inquiry-document.model';
import { ReqState } from '../../../../../types/request-state.model';
import { InqDocumentModalTabs, DocumentTabID } from './inq-document-modal-tabs.component';

interface InqDocumentRequestsFormProps {
  document: InquiryDocument;
  saveState?: ReqState;

  activeTab: DocumentTabID;
  onTabClick: (tabId: DocumentTabID) => void;
  
  onDocumentChange: (document: InquiryDocument) => void;
  onPrintClick: () => void;
  onSaveClick: () => void;
}

interface InqDocumentRequestsFormState {
  requestInput: string;
}

export class InqDocumentRequestsForm extends Component<InqDocumentRequestsFormProps, InqDocumentRequestsFormState> {
  onRequestAdd() {
    const document = { ...this.props.document }
    document.requests = document.requests || [];

    document.requests = [ ...document.requests, this.state.requestInput ];

    this.setState({ requestInput: '' });
    this.props.onDocumentChange(document);
  }

  onRequestRemove(index: number) {
    const docItem = cloneDeep<InquiryDocument>(this.props.document);
    docItem.requests.splice(index, 1);
    this.props.onDocumentChange(docItem);
  }

  getRequestListItems(document: InquiryDocument) {
    if (document && document.requests && document.requests.length > 0) {
      return document.requests.map((request, index) => (
        <div className="hi-docreqsform__request-item d-flex align-items-between">
          {/* <span className="hi-docreqsform__request-date">01/21/20</span> */}
          <p className="hi-docreqsform__request-text">{ request }</p>
          <button className="btn btn-link text-muted" onClick={ () => this.onRequestRemove(index) }>
            <i className="fas fa-times" />
          </button>
        </div>
      ));
    } else {
      return (
        <div className="hi-docreqsform__no-requests-section">
          <p className="hi-docreqsform__no-requests">There are no requests in this document.</p>
        </div>
      )
    }
  }

  getSaveButton() {
    const props = this.props;
    if (props.saveState !== ReqState.IN_PROGRESS) {
      return (
        <button className="btn btn-secondary hi-docreqsform__save-button" onClick={ props.onSaveClick }>
          Save
        </button>
      );
    } else {
      return (
        <button className="btn btn-secondary hi-docreqsform__save-button" disabled>
          <i className="fas fa-cog fa-spin" /> Saving...
        </button>
      )
    }
  }

  renderForm(props: InqDocumentRequestsFormProps, state: InqDocumentRequestsFormState) {
    const document = props.document;
    return (
      <div className="hi-docreqsform">
        <div className="hi-docreqsform__inputs">
          <label className="hi-input-group__label">Add Requests</label>
          <textarea className="form-control hi-input-group__textarea"
            placeholder="Write here"
            value={ state.requestInput }
            onInput={ linkState(this, 'requestInput') } />

          <button className="btn btn-outline-dark hi-docreqsform__add-request-button"
            disabled={ !state.requestInput }
            onClick={ () => this.onRequestAdd() }>
            Add
          </button>
        </div>

        <div className="hi-docreqsform__requests">
          <span className="hi-input-group__label">Requests</span>

          { this.getRequestListItems(document) }
        </div>

        <div className="hi-docreqsform__button-row">
          <button className="btn btn-outline-dark hi-docreqsform__print-button" onClick={ props.onPrintClick }>
            Print
          </button>
          { this.getSaveButton() }
        </div>
      </div>
    );
  }

  render(props: InqDocumentRequestsFormProps, state: InqDocumentRequestsFormState) {
    return (
      <div className="hi-docmodal__tabbed-container">
        <InqDocumentModalTabs activeTab={ props.activeTab }
          onTabClick={ (tabId) => props.onTabClick(tabId) } />

        <div className="hi-docmodal__tab-content">
          { this.renderForm(props, state) }
        </div>
      </div>
    )
  }
}